(function(){
  var p=document.querySelector('[data-popup]'); if(!p) return;
  var tab=document.querySelector('[data-cult-tab]');
  var KEY='wmns_cult_popup';
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'null')}catch(e){return null}}
  function set(v){try{localStorage.setItem(KEY,JSON.stringify(v))}catch(e){}}
  function showTab(on){ if(tab) tab.classList.toggle('is-on',!!on); }
  function open(){p.classList.add('is-open');p.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';showTab(false);
    var em=p.querySelector('input[type=email]'); if(em&&!p.classList.contains('is-done')&&matchMedia('(min-width:750px)').matches) setTimeout(function(){em.focus({preventScroll:true})},450);}
  function close(){p.classList.remove('is-open');p.setAttribute('aria-hidden','true');document.body.style.overflow='';
    var s=get()||{}; if(!s.joined){s.closed=Date.now();set(s);showTab(true);} }
  p.querySelectorAll('[data-popup-close]').forEach(function(b){b.addEventListener('click',close)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&p.classList.contains('is-open'))close()});
  document.querySelectorAll('[data-open-popup]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();var m=document.querySelector('.mmenu');if(m&&m.classList.contains('is-open')){var b=document.querySelector('.hdr__burger');if(b)b.click();}open();})});
  if(tab) tab.addEventListener('click',open);

  /* copy code */
  p.querySelectorAll('[data-copy]').forEach(function(b){b.addEventListener('click',function(){
    var t=b.getAttribute('data-copy');
    (navigator.clipboard?navigator.clipboard.writeText(t):Promise.reject()).then(function(){b.textContent='Copied';setTimeout(function(){b.textContent='Copy'},1800)}).catch(function(){});
  })});

  if(p.querySelector('[data-popup-success]')){set({joined:Date.now()});p.classList.add('is-done');open();return;}
  if(p.querySelector('[data-popup-error]')){open();return;}

  var st=get(); if(st&&st.joined) return;
  if(/\/(cart|checkout|account|challenge)/.test(location.pathname)) return;
  var days=+p.dataset.days||7;
  if(st&&st.closed&&Date.now()-st.closed<days*864e5){ showTab(true); return; }

  var fired=false;
  function fire(){if(fired)return;fired=true;open();}
  setTimeout(fire,(+p.dataset.delay||6)*1000);
  window.addEventListener('scroll',function(){if(window.scrollY>window.innerHeight*1.1)fire();},{passive:true});
  /* desktop exit intent */
  document.addEventListener('mouseout',function(e){ if(!e.relatedTarget&&e.clientY<=0) fire(); });
})();
